/* eslint-disable import/prefer-default-export */
export const SwitchStyles = {
    root: {
        width: 28,
        height: 16,
        padding: 0,
        display: 'flex',
    },
    switchBase: {
        padding: 2,
        color: 'var(--neutralGray)',
        '&$checked': {
            transform: 'translateX(12px)',
            color: 'var(--white)',
            '& + $track': {
                opacity: 1,
                backgroundColor: 'var(--fashionPink)',
                borderColor: 'var(--fashionPink)',
            },
        },
    },
    thumb: {
        width: 12,
        height: 12,
        boxShadow: 'none',
    },
    track: {
        border: '1px solid var(--neutralGray)',
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: 'var(--white)',
    },
    checked: {},
};
